import React, {Component} from "react";
import DataTable from "react-data-table-component";
import {Link} from "react-router-dom";
import ApiConnect from "../../../../Utils/ApiConnect";

export default class Formula extends Component {
  constructor() {
    super();
    this.state = {
      formulaData: [],
      filterText: "",
    };
    this.columns = [
      {
        name: "Product Name",
        selector: row => row.name,
        sortable: true,
      },
      {
        name: "Material",
        selector: row => row.category,
        sortable: true,
        cell: (row) => {
          return row.material.map((mat, index) => (
            <p key={index}>
              {mat}
              <br />
            </p>
          ));
        },
      },
      {
        name: "Qty",
        selector: row => row.qty,
        sortable: true,
        cell: (row) => {
          return row.qty.map((mat, index) => (
            <p key={index}>
              {mat}
              {row.unit[index]}
              <br />
            </p>
          ));
        },
      },
      {
        name: "Production",
        selector: row => row.production,
        sortable: true,
        cell: (row) => {
          return row.production + "" + row.prd_unit;
        },
      },
      {
        name: "Action",
        selector: row => row.action,
        className: "table-actions",
        width: "150px",
        sortable: false,
        cell: (row) => {
          return (
            <React.Fragment>
              <button
                className="table-action btn btn-square btn-pure hover-info"
              >
                <span className="material-icons-outlined">visibility</span>
              </button>
              <Link
                className="table-action btn btn-square btn-pure hover-warning"
              >
                <span className="material-icons-outlined">edit_note</span>
              </Link>
              <button
                disabled={false}
                className="table-action btn btn-square btn-pure hover-danger"
              >
                <span className="material-icons-outlined">delete</span>
              </button>
            </React.Fragment>
          );
        },
      },
      ];
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  componentDidMount() {
    this.fetchFormulas();
  }
  fetchFormulas() {
    ApiConnect.get("/Module/Inventory/Consumption/Formula")
      .then((response) => {
        this.setState({ formulaData: response.data });
      })
      .catch((error) => console.log(error));
  }
  render() {
    const filteredData = this.state.formulaData.filter(item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
      )
    );
    return (
      <div className="container">
        <div className="col-md-12 col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="dataTables_wrapper">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    onChange={e => this.setState({ filterText: e.target.value })}
                  />
                </div>
                <DataTable
                  className="table table-separated"
                  keyField="id"
                  columns={this.columns}
                  data={filteredData}
                  pagination
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                  paginationPerPage={10}
                  customStyles={this.customStyles}
                  filter
                  exportable
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
